module.exports = __webpack_public_path__ + "img/abc.f1e4480b.png";